import React from 'react';
import { View, StyleSheet, Pressable } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
//
const Modal = React.lazy(() => import('@web-components/common/Modal'));
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import OtpForm from '@web-components/OtpForm';
import { isWeb } from '~global/screens';
// import Colors from '~global/Colors';

const ModalVerifyAccount = (props) => {
  const { navigation } = props;
  const dispatch = useDispatch();
  const { isShow, data } = useSelector((state) => state.modal.verifyAccount);
  const closeModal = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'verifyAccount' });
  };

  return (
    <Modal isVisible={isShow} style={styles.modal} onClose={closeModal}>
      <View style={styles.container}>
        <OtpForm
          route={{ params: data }}
          navigation={navigation.current ? navigation.current : navigation}
        />
      </View>
      <Pressable style={styles.close} onPress={closeModal}>
        <WithLocalSvg asset={require('~assets/img/common/icon-close.svg')} />
      </Pressable>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modal: { borderRadius: 8 },
  container: {
    borderRadius: 8,
    paddingTop: 24,
    paddingHorizontal: 8,
    paddingBottom: 8,
    overflow: 'hidden',
    width: 500,
  },
  close: {
    ...(isWeb && { cursor: 'pointer' }),
    position: 'absolute',
    top: 24,
    right: 24,
  },
});

export default ModalVerifyAccount;
